import { Component, inject } from '@angular/core';
import { ColumnRendererComponentV3 } from '@gea/digital-ui-lib';
import { DataSheet } from 'src/app/custom/models/classes/datasheet.model';
import { ProductDataSheetService } from 'src/app/custom/services/product/product-datasheet.service';

@Component({
  selector: 'custom-attachment-download-renderer',
  template: '<a [href]="downloadUrl">Download</a>',
})
export class CustomAttachmentDownloadRendererComponent
  implements ColumnRendererComponentV3<DataSheet>
{
  productDataSheetService = inject(ProductDataSheetService);

  rowData?: DataSheet;

  get downloadUrl() {
    if (this.rowData) {
      return this.productDataSheetService.getDownloadUrl(this.rowData);
    }
    return undefined;
  }

  get url() {
    if (this.rowData) {
      return this.productDataSheetService.getUrl(this.rowData);
    }
    return undefined;
  }
}
